export const actionTypes = {
    REGISTER_USER: "REGISTER_USER",
    LOGIN_USER: "LOGIN_USER",
    ADD_TO_CART: "ADD_TO_CART",
    LOG_OUT_USER: "LOG_OUT_USER",
    DELETE_CART_ITEM: "DELETE_CART_ITEM",
    ADD_ITEMS_TO_MY_ORDERS: "ADD_ITEMS_TO_MY_ORDERS",
    DELETE_ALL_CART_ITEM: "DELETE_ALL_CART_ITEM"
}